export default __webpack_public_path__ + "static/media/LogoLogin.f5cbcac7.svg";